<template>
    <section class="articles-category">
        <h2 class="category-title">
            <span href="#">Search Results</span>
        </h2>
        <ul class="category-articles articles-column-1">
        <template v-if="searchResults.length">
            <Skeleton v-if="isTranslationsLoading" height="1.5rem" class="mb-3" borderRadius="10px"></Skeleton>
            <li v-for="results in searchResults.slice(startIdx, endIdx)" class="mb-3">
                <Skeleton v-if="isTranslationsLoading" height="1.5rem" class="mb-3" borderRadius="10px"></Skeleton>
                <router-link class="search-articles-link text-wrap lh-lg d-inline" :to="routeTo(results.document_id)" v-else>
                    {{
                    results.title.length > 50
                    ? isTranslationLoaded(results.title).slice(0, 50).split(' ').slice(0, -1).join(' ') + '...'
                    : isTranslationLoaded(results.title)
                    }}
                </router-link>

                <template v-if="results?.article_category_title">   
                    <router-link class="d-inline" :to="routeToCategoryDetails(results.article_category)">
                        <span class="text-sm border border-secondary px-2 py-1 rounded-pill text-dark fw-bold ms-2">
                            {{ isTranslationLoaded(results.article_category_title) }}
                        </span>
                    </router-link>
                </template>
                
                <Skeleton v-if="isTranslationsLoading" height="1.5rem" class="mb-3" borderRadius="10px"></Skeleton>
                <router-link :to="routeTo(results.id)" class="text-wrap" v-else>
                    <h6 class="text-sm" v-html="getSearchSubstr(isTranslationLoaded(results.description))"></h6>
                </router-link>
            </li>

            <div class="" v-if="!isContentLoading">
                <div class="d-flex">
                    <div class="prevlink me-2" v-if="pageNumber !== 1">
                    <a href="javascript:void(0);" class="btn" @click="prevPageSearch"><i class="fa fa-chevron-left"></i></a>
                    </div>
                    <div class="nextlink" v-if="searchResults.length > pageLimit && pageNumber !== Math.ceil(searchResults.length) / pageLimit && searchResults.slice(startIdx, endIdx).length >= pageLimit">
                    <a href="javascript:void(0);" class="btn" @click="nextPageSearch">
                        <i class="fa fa-chevron-right"></i>
                    </a>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <li>No result found</li>
        </template>
        </ul>
    </section>
</template>
<script>
export default {
  name: 'SearchResultWrapper',
  props: [
    'searchResults',
    'isTranslationsLoading',
    'isTranslationLoaded',
    'getSearchSubstr',
    'startIdx',
    'endIdx',
    'pageNumber',
    'pageLimit',
    'prevPageSearch',
    'nextPageSearch',
    'routeToCategoryDetails',
    'successArticleSearchId',
    'library_key',
    'isCustomSubDomain',
    'isContentLoading'
],
methods: {
    routeTo(resultId) {
      let url = '';
      if (this.isCustomSubDomain) {
        url = '/article/details/' + resultId;
      } else {
        url = '/article/details/' + this.library_key + '/' + resultId;
      }
      if(this.successArticleSearchId) {
        url += '?successArticleSearchId=' + this.successArticleSearchId
      }
      return url;
    },
}
}
</script>